<template>
    <div class="container px-0">
        <div class="row" v-if="loading == true">
            <div class="col-12">
				<loader></loader>
            </div>
        </div>

        <div class="row" v-else>
            <div class="col-12">
                <div class="flex-table">
                    <template v-if="filteredSnagList.length > 0">
                        <list-item
                            v-for="(snag, index) in filteredSnagList"
                            :key="index"
                            @click="showSnagItem(snag.form_id)"
                        >
                        <!-- id date name location  -->
                            <template slot="title">
                                <div class="">
                                    <h5 class="mb-0 text-dark font-weight-bold">{{snag.title}}</h5>
                                    <!-- number -->
                                    <div class="d-flex W-100 justify-content-between">
                                            <div>
                                                <h6 class="mb-0 text-dark font-weight-normal">{{snag.ticket_no}}<span> . &nbsp;</span></h6>
                                            </div>
                                            <div>
                                                <h6 class="mb-0 text-dark font-weight-normal">{{snag.date_opened}}  <span> . &nbsp;</span></h6>
                                            </div>
                                            <div>
                                                <h6 class="mb-0 text-dark font-weight-normal">{{snag.assigned_user}}  <span> . &nbsp; </span></h6>
                                            </div>
                                            <div>
                                                <h6 class="mb-0 text-dark font-weight-normal">{{snag.location}}</h6>
                                            </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="center">
                                <div class="badge badge--sm" :class="`badge--${snag.form_status.color}`">{{ snag.priority }}</div>
                            </template>
                        </list-item>
                    </template>
                    <template v-else >
                        <div class="text-center">
                            <h5 v-if="status === 'completed'" class="m-4 mx-auto text-dark">No completed snag list items</h5>
                            <h5 v-else class="m-4 mx-auto text-dark">No planned snag list items</h5>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import ListItem from "../ListComponent/ListItem";
	import Loader from "../general_components/Loader";
    export default {
		name: "SnagListComponent",
        components: {Loader, ListItem},
        props: [
            'load_url',
            'status',
            'show_url'
        ],

        data(){
		    return {
		        loading: false,
                snag_list_items: [],
            }
        },

        mounted() {
            this.load();
        },

        methods: {
            load(){
                if (this.loading){
                    return;
                }

                this.loading = true;

                axios.get(this.load_url)
                    .then((response) => {
                        this.snag_list_items = response.data;
                        this.loading = false;
                    });
            },
            showSnagItem(form_submission_id){
                window.location.href = this.show_url.replace('?', form_submission_id);
            }
        },
        computed: {
            filteredSnagList() {
               return this.snag_list_items.filter(issue => issue.status == this.status)
            }
        }
	}
</script>
